import React from "react";
import SaitRowActionCell from "./SaitRowActionCell.jsx";

export default function SaitRowAction(config) {
	return {
		headerName: "",
		field: config.id,
		objmod: config.objmod,
		width: 45,
		minWidth: 40,
		actionColumn: true,
		sortable: false,
		resizable: false,
		disableColumnMenu: true,
		display: "flex",
		hidden: config.hidden,
		renderCell: (params) => <SaitRowActionCell config={config} params={params} />,
		//Estratto in componente separato per evitare di chiamare Hook (es: useSelector/useContext) all'interno di un eventuale ciclo
	};
}
